import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config';
import locale from './assets/lang-ru';
import ConfirmationService from 'primevue/confirmationservice';
import '@/assets/styles.scss';
import FocusTrap from 'primevue/focustrap';
import * as ConfirmDialog from 'vuejs-confirm-dialog';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);
app.directive('focustrap', FocusTrap);
app.directive('tooltip', Tooltip);
app.use(PrimeVue, { ripple: true, locale});
app.use(ConfirmationService);
app.use(ConfirmDialog);
app.use(store).use(router).mount('#app')